import { Tag } from 'antd';
import gql from 'graphql-tag';
import React from 'react';
import { useAuthedQuery } from 'utils/qlAuth';

interface LeonardoUserData {
  apiConcurrencySlots: number;
  apiPaidTokens: number | null;
  apiPlanTokenRenewalDate: string;
  apiSubscriptionTokens: number;
  paidTokens: number;
  subscriptionGptTokens: number;
  subscriptionModelTokens: number;
  subscriptionTokens: number;
  tokenRenewalDate: string;
  user: {
    id: string;
    username: string;
  };
}

export const LeonardoUser = (props: {}) => {
  const qLeonardoUser = useAuthedQuery(
    gql`
      query StoryboardController_leonardoUser {
        StoryboardController_leonardoUser {
          user_details
        }
      }
    `,
  );

  React.useEffect(() => {
    if (qLeonardoUser.data?.StoryboardController_leonardoUser) {
      console.log('Leonardo User:', qLeonardoUser.data.StoryboardController_leonardoUser);
    }
  }, [qLeonardoUser.data]);

  if (!qLeonardoUser.data || !qLeonardoUser.data.StoryboardController_leonardoUser) {
    return <div>Loading...</div>;
  }

  const me: LeonardoUserData = qLeonardoUser.data?.StoryboardController_leonardoUser?.user_details?.[0];

  return <Tag>Api tokens: {me.apiSubscriptionTokens + me.apiPaidTokens}</Tag>;
};
